import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import RowAddButton from '@/components/buttons/RowAddButton';
import { addLookupItem } from '../../dictionaries/actions';

const LookupTableFooter = ({
  colSpan,
  showEmptyRow,
}) => (
  <Table.Footer fullWidth>
    <Table.Row>
      <Table.HeaderCell colSpan={colSpan}>
        <RowAddButton entity="lookup" onClick={showEmptyRow} />
      </Table.HeaderCell>
    </Table.Row>
  </Table.Footer>
);

const mapDispatchToProps = {
  showEmptyRow: addLookupItem,
};

export default connect(null, mapDispatchToProps)(LookupTableFooter);
